/**
 * Icon + colour for a scalar User Attributes field, so a long single-column list of names can be
 * scanned by shape and colour instead of read word by word. Matched on the field key, because the
 * param list only carries a key and a primitive type — nothing that says what the value means.
 */
export type ParamIcon = {
  // Font Awesome 5 free classes; the admin bundle already ships it (sb-admin-2)
  icon: string;
  // Maps to a .uv-icon-* rule in UserView.css
  tone: 'coin' | 'diamond' | 'boost' | 'progress' | 'premium' | 'energy' | 'neutral';
};

const DEFAULT_ICON: ParamIcon = { icon: 'fas fa-hashtag', tone: 'neutral' };

export const paramIcon = (key: string): ParamIcon => {
  if (key.startsWith('energy')) return { icon: 'fas fa-battery-half', tone: 'energy' };
  if (key.toLowerCase().includes('boost')) return { icon: 'fas fa-bolt', tone: 'boost' };
  if (key.includes('coin')) return { icon: 'fas fa-coins', tone: 'coin' };
  if (key.includes('diamond')) return { icon: 'fas fa-gem', tone: 'diamond' };
  if (key.includes('Ticket')) return { icon: 'fas fa-ticket-alt', tone: 'progress' };
  if (key.includes('accolade')) return { icon: 'fas fa-award', tone: 'premium' };
  if (key.includes('StampCard') || key === 'stampCards') return { icon: 'fas fa-stamp', tone: 'progress' };
  if (key === 'premiumDays' || key === 'vipDays') return { icon: 'fas fa-crown', tone: 'premium' };
  if (key === 'userLevel') return { icon: 'fas fa-layer-group', tone: 'progress' };
  if (key.includes('ProgressToNextLevel')) return { icon: 'fas fa-chart-line', tone: 'progress' };
  if (key === 'liveEventCurrency') return { icon: 'fas fa-broadcast-tower', tone: 'diamond' };
  if (key.endsWith('Id')) return { icon: 'fas fa-fingerprint', tone: 'neutral' };

  return DEFAULT_ICON;
};
